import {useBudgetStore} from 'store/Budget';
import {useHistoryStore} from 'store/History';
import {saved} from 'core/LifeCycle';

export function useSavedMoney(): number {
  const budget = useBudgetStore();
  const history = useHistoryStore();
  return saved(budget, history);
}
